import apiClient from "../../client/apiClient"

export type TeacherWorkItem = {
  course_structure_id: string
  subject_name: string
  subject_id?: string
  class_name: string
  class_id?: string
  class_order?: number
  /** Board/system name (e.g. "AKU-EB", "Matric") -- distinguishes two
   *  classes sharing the same display name across different boards. */
  system_name?: string
  section_name: string
  section_id?: string
  session_name: string
  session_id?: string
  campus_name?: string
  campus_id?: string
  breakdown_title: string
  /** ResultBreakdown ObjectId — use this for /api/marks-entry/* calls */
  breakdown_id: string | null
  breakdown_status?: string | null
  /** Term ObjectId — for reference / is_final matching only */
  exam_term_id: string
  exam_term_name?: string
  is_final: boolean
  award_slip_id: string | null
  slip_status: string
  complete: boolean
  entered_marks: number
  expected_marks: number
  total_marks: number
  student_count?: number
}

export type TeacherAssignmentItem = {
  id: string
  user_id: string
  class_id: string
  class_name: string
  section_id: string
  section_name: string
  subject_id: string
  subject_name: string
  campus_id: string
  campus_name: string
  is_class_teacher: boolean
}

export type TeacherMe = {
  user: {
    _id: string
    firstName: string
    lastName: string
    email: string
    role: string | { _id: string; name: string }
  }
  active_session: {
    _id: string
    name?: string
    title?: string
    startDate?: string
    endDate?: string
  } | null
}

export const getTeacherMe = async (): Promise<{ success: boolean; data: TeacherMe }> => {
  const res = await apiClient({ method: "GET", url: "/teacher/me" })
  return res.data
}

export const getTeacherAssignments = async (): Promise<{
  success: boolean
  data: { items: TeacherAssignmentItem[] }
}> => {
  const res = await apiClient({ method: "GET", url: "/teacher/me/assignments" })
  return res.data
}

export const getTeacherWorkItems = async (): Promise<{
  success: boolean
  data: { items: TeacherWorkItem[] }
}> => {
  const res = await apiClient({ method: "GET", url: "/teacher/me/work-items" })
  return res.data
}

export const submitMarks = async (awardSlipId: string): Promise<{ success: boolean; message: string }> => {
  const res = await apiClient({
    method: "POST",
    url: "/teacher/me/submit-marks",
    data: { awardSlipId },
  })
  return res.data
}

